const THEMES = [
    { bg: 'bg-yellow-200 dark:bg-yellow-dark-200' },
    { bg: 'bg-pink-200 dark:bg-pink-dark-200' },
    { bg: 'bg-blue-200 dark:bg-blue-dark-200' },
];

export function getRandomTheme() {
    return THEMES[Math.floor(Math.random() * THEMES.length)];
}
